module.exports = __webpack_public_path__ + "static/img/win10_4.e17f58e.png";